import ReservePurchasedGiftModal from './reserve-purchased-gift-modal.tsx'

export default ReservePurchasedGiftModal
